export default __webpack_public_path__ + "static/TaleFin_Logo_White_RGB_1600px-819f650477d958116f86998f33694cce.png";